import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { ReactComponent as JaldiLogo } from "../../../../assets/SvgIcons/logo-jaldi.svg";
import { ReactComponent as JaldiLogoWhite } from "../../../../assets/SvgIcons/jaldi-logo-white.svg";
import { ReactComponent as VidhiLogo } from "../../../../assets/SvgIcons/vidhilogoRed.svg";
import { Grid } from "@mui/material";
import * as CONST from "../../../../../src/utils/Constants";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import useCustomLogic from "../../../../Hooks/UseCustomLogic";
import LeftArrow from "../../../../assets/SvgIcons/LeftArrow.svg";
import { theme } from "../../../../themes/theme";

export default function BuildingSideDrawer({ selectedMenu, setSelectedMenu }) {
  console.log("🚀 ~ BuildingSideDrawer ~ selectedMenu:", selectedMenu);

  const { isSm } = useCustomLogic();

  const [menu, setMenu] = React.useState([
    "Snapshot",
    "Litigant Profile",
    "Getting There",
    "Navigation",
    "Waiting Area",
    "Hygiene",
    "Barrier-free Access",
    "Case Display",
    "Amenities",
    "Security",
    "Website",
    "Overview",
  ]);

  const [open, setOpen] = React.useState(false);

  const handleDynamicWidth = () => {
    return {
      width: isSm ? 200 : 300,
    };
  };

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const DrawerList = (
    <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
      <List>
        {menu.map((text, index) => (
          <ListItem key={text} disablePadding onClick={() => setSelectedMenu(text)}>
            <ListItemButton disabled>
              <ListItemText
                primary={text}
                variant={"body1"}
                sx={{
                  color: text === selectedMenu && "#DC002D",
                  textDecoration: text === selectedMenu && "underline",
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      {/* <Button onClick={toggleDrawer(true)}>open</Button> */}
      <Button
        onClick={toggleDrawer(true)}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
          width: "32px",
          height: "40px",
          padding: "18px",
          borderRadius: "10px",
          gap: "24px",
          minWidth: "50px",
          backgroundColor: theme.palette.grey[400],
        }}
      >
        <img
          onClick={toggleDrawer(true)}
          src={LeftArrow}
          style={{ width: "22px", height: "22px", transform: "rotate(180deg)" }}
          alt="arrow"
        />
      </Button>

      {/* <img
          onClick={toggleDrawer(true)}
            src={LeftArrow}
            style={{ width: "22px", height: "22px" }}
            alt="arrow"
          /> */}

      <Drawer open={open} onClose={toggleDrawer(false)} anchor="left">
        <Grid container direction="column">
          {/* Vidhi Logo */}
          <Grid container justifyContent={"center"} sx={{ pt: "20px", pb: "10px" }}>
            <a href={CONST.VIDHI_WEBSITE_URL} target="_blank" rel="noopener noreferrer">
              <VidhiLogo style={handleDynamicWidth()} />
            </a>
          </Grid>

          {/* Jaldi logo and Close Icon */}
          <Grid
            container
            justifyContent={"space-between"}
            alignItems="center"
            sx={{
              height: "80px",
              px: "25px",
              backgroundColor: "#dc002d",
            }}
          >
            <a href="/">
              <JaldiLogoWhite
                style={handleDynamicWidth()} //sx does not work on svg component
              />
            </a>

            <HighlightOffIcon
              fontSize="large"
              onClick={handleClose}
              sx={{ color: "#ffffff", cursor: "pointer" }}
            />
          </Grid>
        </Grid>

        {DrawerList}
      </Drawer>
    </div>
  );
}
